<div class="portfolio-wrap gap-1 pt-1 pb-1 gap-sm-2 px-sm-3" (click)="onDropdownChange($event)" [class.active]="showPortfolio"  joyrideStep="pro.portfolio" title="Portfolio" text="In addition to seeing your total portfolio value, you can check your balances broken down by fiat and crypto here." i18n-title="@@tourGuide.pro.portfolio.title" i18n-text="@@tourGuide.pro.portfolio.text">
  <div class="d-flex flex-column text-end">
    <div class="text-xs text-gray" i18n="@@userPortfolio.balance.title">TOTAL PORTFOLIO</div>
    <div class="portfolio-amount">{{defaultFiatCurrency}} {{getTotal() | number:'0.2-2'}}</div>
  </div>
  <div class="icon portfolio-chevron"><i class="icon-bold-chevron-down"></i></div>
</div>
<modal-dropdown (showDropdownChange)="onDropdownChange($event)" [showDropdown]="showPortfolio" [alignContent]="'End'">
  <ng-content *ngIf="showPortfolio" select="[dropdown]"></ng-content>
</modal-dropdown>
